import type { RadarSearch } from '~/features/opportunity-radar/search-schema'
import { createFileRoute } from '@tanstack/react-router'
import { competitionScopesQueryOptions } from '~/features/competition-scopes/query-options'
import { OpportunityRadarPage } from '~/features/opportunity-radar/components'
import { radarEventsInfiniteQueryOptions } from '~/features/opportunity-radar/query-options'
import { parseRadarSearch } from '~/features/opportunity-radar/search-schema'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/$locale/radar/')({
  validateSearch: (search): RadarSearch => parseRadarSearch(search),
  head: ({ params }) =>
    seo({
      title: 'BallPeek — 看比赛资料、球队历史和市场变化，先看清再判断',
      description: '查看赛程、比分、球队历史、参考赔率和市场变化。页面会提示资料来源、更新时间和缺少哪些资料，帮助你先看清比赛情况，再自己判断，不承诺稳赚结果。',
      pathname: '/radar',
      locale: params.locale,
    }),
  loader: async ({ context, location }) => {
    const search = parseRadarSearch(location.search)
    await Promise.all([
      context.queryClient.prefetchQuery(competitionScopesQueryOptions()),
      context.queryClient.prefetchInfiniteQuery(radarEventsInfiniteQueryOptions({
        tab: 'matches',
        pageSize: 20,
        competitionCode: search.competitionCode,
        season: search.season,
      })),
    ])
  },
  component: LocalizedOpportunityRadarPage,
})

function LocalizedOpportunityRadarPage() {
  return <OpportunityRadarPage routePath="/$locale/radar/" />
}
